import { body, cn, paragraph } from "@dalmatech/ui"

const content = cn(
  "flex flex-col gap-6 overflow-y-auto p-4 pb-10 w-full md:w-[660px] flex-1 min-h-0"
)
const sectionTitle = cn(body({ size: "sm", className: "font-bold text-neutral-500" }))
const sectionWrapper = cn("flex flex-col gap-3")

// Accordion grouped in a single card
const accordionWrapper = cn("flex flex-col rounded-xl bg-neutral-50 overflow-hidden px-2")
const accordionItem = cn(
  "ring-0 rounded-none hover:ring-0 hover:bg-transparent focus-within:ring-0",
  "relative [&:not(:last-child)]:after:absolute [&:not(:last-child)]:after:bottom-0 [&:not(:last-child)]:after:left-4 [&:not(:last-child)]:after:right-4 [&:not(:last-child)]:after:h-px [&:not(:last-child)]:after:bg-neutral-200"
)
const accordionTrigger = cn("px-3 py-3 min-h-[56px]")
const accordionTriggerText = cn(body({ size: "sm", className: "text-left font-bold text-black" }))
const accordionBody = cn(
  paragraph({ size: "sm", className: " text-neutral-600 whitespace-pre-line" })
)

// Documents section
const documentsCard = cn("flex flex-col overflow-hidden rounded-xl bg-neutral-50 p-2")
const documentRow = cn(
  "relative flex min-h-[56px] items-center gap-3 rounded-xl px-3 py-3",
  "[&:not(:last-child)]:after:absolute [&:not(:last-child)]:after:bottom-0 [&:not(:last-child)]:after:left-0 [&:not(:last-child)]:after:right-0 [&:not(:last-child)]:after:h-px [&:not(:last-child)]:after:bg-neutral-200"
)
const documentLabel = cn(body({ size: "sm", className: "min-w-0 flex-1 font-bold text-black" }))
const documentViewButton = cn(
  "flex h-9  shrink-0 items-center justify-center rounded-full bg-neutral-100  ",
  "font-buenosAires text-sm font-bold leading-5 text-neutral-700 hover:bg-neutral-200 transition-colors px-3 py-2"
)

const drawerContent = cn(
  "fixed bottom-0 left-0 right-0 z-50 mt-24 flex flex-col rounded-t-[2rem] bg-white max-h-[90vh]"
)
const drawerHeader = cn(
  "flex shrink-0 items-center justify-between border-b border-neutral-200 px-6 py-4"
)
const drawerTitle = cn(
  "flex-1 text-center font-buenosAires text-base font-bold leading-6 tracking-tight text-black"
)
const drawerCloseButton = cn(
  "flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200 transition-colors"
)

// Desktop dialog
const dialogContent = cn(
  "fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2",
  "flex max-h-[768px] max-w-[660px] flex-col overflow-hidden",
  "rounded-2xl border border-neutral-200 bg-white shadow-lg",
  "data-[state=open]:animate-in data-[state=closed]:animate-out",
  "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
  "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
  "duration-200 focus:outline-none"
)
const dialogHeader = cn(
  "flex shrink-0 items-center justify-center gap-8 border-b border-neutral-200 px-6 py-4"
)
const dialogTitle = cn(
  "flex-1 text-center font-buenosAires text-base font-bold leading-6 tracking-tight text-black"
)
const dialogCloseButton = cn(
  "flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200 transition-colors"
)

export {
  accordionBody,
  accordionItem,
  accordionTrigger,
  accordionTriggerText,
  accordionWrapper,
  content,
  dialogCloseButton,
  dialogContent,
  dialogHeader,
  dialogTitle,
  documentLabel,
  documentRow,
  documentViewButton,
  documentsCard,
  drawerCloseButton,
  drawerContent,
  drawerHeader,
  drawerTitle,
  sectionTitle,
  sectionWrapper,
}
